import React from "react";
import { Footer } from "../components/footer/Footer";
import { Outlet } from "react-router-dom";
import { AppToolbar } from "../components/toolbar/AppToolbar";
import styles from "./layout.module.scss";
export const PortalLayout = () => {
    return React.createElement(React.Fragment, null,
        React.createElement("div", { className: "app-header" },
            React.createElement("div", { className: styles.toolbarContainer },
                React.createElement(AppToolbar, null)),
            React.createElement("div", { id: "app-content" },
                React.createElement("div", { className: styles.containerWrapper },
                    React.createElement("div", { className: styles.containerFluid },
                        React.createElement(Outlet, null))),
                React.createElement(Footer, null))));
};
